module.exports = __webpack_public_path__ + "img/编组(1).38b42e17.png";